import { apiSlice } from "api/api.slice";
import {
  fetchBriefingResponseSchema,
  monitorProgressGenerateBriefingResponseSchema,
  triggerGenerateBriefingResponseSchema,
} from "api/schemas/briefingApiSchema";
import type {
  FetchBriefingResponse,
  MonitorProgressGenerateBriefingResponse,
  TriggerGenerateBriefingResponse,
} from "domains/briefing/types";

export type BriefingGenerationStatus = "Processing" | "Error" | "Done";

type TriggerBriefingGenerationRequest = {
  topicId: string;
  isFurtherReadingEnabled: boolean;
  isForesightEnabled: boolean;
};

type MonitorBriefingGenerationRequest = {
  jobId: string;
};

type FetchBriefingRequest = {
  briefingId: string;
};

export const briefingApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    triggerBriefingGeneration: build.mutation<TriggerGenerateBriefingResponse, TriggerBriefingGenerationRequest>({
      query: ({ topicId, isForesightEnabled, isFurtherReadingEnabled }) => ({
        method: "POST",
        url: `/live_briefing/topic/${topicId}`,
        body: {
          options: {
            include_foresight: isForesightEnabled,
            include_reports: isFurtherReadingEnabled,
            include_insight: true,
            include_watermark: false,
          },
        },
        headers: { "cache-control": "no-cache, no-store, must-revalidate", expires: "0" },
        schema: triggerGenerateBriefingResponseSchema,
      }),
    }),
    monitorBriefingGeneration: build.query<MonitorProgressGenerateBriefingResponse, MonitorBriefingGenerationRequest>({
      query: ({ jobId }) => ({
        url: `/live_briefing/job/${jobId}/status`,
        headers: { "cache-control": "no-cache, no-store, must-revalidate", expires: "0" },
        schema: monitorProgressGenerateBriefingResponseSchema,
      }),
    }),
    fetchGeneratedBriefing: build.query<FetchBriefingResponse, FetchBriefingRequest>({
      query: ({ briefingId }) => ({
        url: `/live_briefing/job/${briefingId}/output`,
        headers: { "cache-control": "no-cache, no-store, must-revalidate", expires: "0" },
        schema: fetchBriefingResponseSchema,
      }),
    }),
  }),
});
